import { call } from 'redux-saga/effects';
import { eventBus } from 'utils/eventBus';

export function* mobileStopScreenshareRequestedSaga() {
  yield call(eventBus.sendMessage, 'mobileStopScreenshareRequested', {}, null);
}
